import { render, staticRenderFns } from "./SafariPlayer.vue?vue&type=template&id=c9148922&scoped=true&"
import script from "./SafariPlayer.vue?vue&type=script&lang=js&"
export * from "./SafariPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SafariPlayer.vue?vue&type=style&index=0&id=c9148922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9148922",
  null
  
)

export default component.exports